import EventHubMixin from '@/mixins/EventHub.js'

export default
{
    name: 'app-push-button',

    mixins:
    [
        EventHubMixin
    ],

    props:
    {
        visible: { type: Boolean, default: false },
        active: { type: Boolean, default: false },
        to: { type: Object, default: () => {} },
        text: { type: String, default: '' },
        frequency: { type: Number, default: 0.3 }
    },

    data()
    {
        return {
            dataVisible: false,
            dataActive: false
        }
    },

    watch:
    {
        active: function()
        {
            if(!this.active)
            {
                this.dataActive = false
            }
        },
        visible: function()
        {
            if(this.blinkInterval)
            {
                window.clearInterval(this.blinkInterval)
                this.blinkInterval = null
            }

            if(this.visible)
            {
                this.blinkInterval = window.setInterval(() =>
                {
                    this.dataVisible = !this.dataVisible

                    if(this.dataVisible && this.active)
                    {
                        this.dataActive = true

                        window.clearInterval(this.blinkInterval)
                        this.blinkInterval = null
                    }
                }, this.frequency * 1000)
            }
            else
            {
                this.dataVisible = false
            }
        }
    },

    created()
    {
        this.blinkInterval = null
    },

    methods:
    {
        onMouseEnter(_event)
        {
            this.$eventHub.$emit('sound.play', 'pushButton')
            this.$eventHub.$emit('grid.focusItem', _event.target)
        },

        onMouseLeave()
        {
            this.$eventHub.$emit('grid.unfocusItem')
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/app-push-button/script.js